// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1thsc","column":"styles_column__fDlSd","row":"styles_row__2pMIx","btn":"styles_btn__1-_Ld"};